const data = [
  {
    title: 'นางสาว วัลลิภา  อุทกศิริ',
    detail: '',
    store: ' ท๊อฟฟี่โฮลเซลล์ เปลี่ยนเป็น คลังพลาซ่า',
    province: 'นครราชสีมา',
    thumb: '/assets/img/goose-breast-thumb.jpg',
    rate: 5,
    key: 0
  },
  {
    title: 'นางสาว รขนก พุฒพิมาย',
    detail: '',
    store: ' ท๊อฟฟี่โฮลเซลล์ เปลี่ยนเป็น คลังพลาซ่า',
    province: 'นครราชสีมา',
    thumb: '/assets/img/goose-breast-thumb.jpg',
    rate: 4,
    key: 1
  },
  {
    title: 'นาง สุนทรี ทุมนาหาด',
    detail: '',
    store: ' ท๊อฟฟี่โฮลเซลล์ เปลี่ยนเป็น คลังพลาซ่า',
    province: 'นครราชสีมา',
    thumb: '/assets/img/goose-breast-thumb.jpg',
    rate: 5,
    key: 2
  },
  {
    title: 'นางสาว สุดาพร อินเนา',
    detail: '',
    store: ' ท๊อฟฟี่โฮลเซลล์ เปลี่ยนเป็น คลังพลาซ่า',
    province: 'นครราชสีมา',
    thumb: '/assets/img/goose-breast-thumb.jpg',
    rate: 3,
    key: 3
  },
  {
    title: 'นางสาว ปรียา รุจิยาปนนท์',
    detail: '',
    store: ' ท๊อฟฟี่โฮลเซลล์ เปลี่ยนเป็น คลังพลาซ่า',
    province: 'นครราชสีมา',
    thumb: '/assets/img/goose-breast-thumb.jpg',
    rate: 2,
    key: 4
  },
  {
    title: 'นางสาว น้ำฝน  พลสิงห์',
    detail: '',
    store: ' ท๊อฟฟี่โฮลเซลล์ เปลี่ยนเป็น คลังพลาซ่า',
    province: 'นครราชสีมา',
    thumb: '/assets/img/goose-breast-thumb.jpg',
    rate: 5,
    key: 5
  },
  {
    title: 'นางสาว ปัทมาภรณ์ จงกลนิธารณ์',
    detail: '',
    store: ' ท๊อฟฟี่โฮลเซลล์ เปลี่ยนเป็น คลังพลาซ่า',
    province: 'นครราชสีมา',
    thumb: '/assets/img/goose-breast-thumb.jpg',
    rate: 4,
    key: 6
  }
]
export default data
